import { render, staticRenderFns } from "./CustomerReferralTreeNode.vue?vue&type=template&id=48f613b2&"
import script from "./CustomerReferralTreeNode.vue?vue&type=script&lang=js&"
export * from "./CustomerReferralTreeNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports